var render = function render(){var _vm=this,_c=_vm._self._c;return _c('client-only',[_c('div',{ref:"mapElement",staticClass:"leaflet-map"},[(_vm.activeMarker)?_c('div',{ref:"popup",staticClass:"map-popup"},[_vm._t("popup",function(){return [_c('GridItem',{staticClass:"map-popup-block",attrs:{"block":_vm.activeMarkerEntry}})]},{"entry":_vm.activeMarkerEntry})],2):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }